<template>
    <modal @before-open="beforeOpen" height="auto" :max-width="500" :scrollable=true name="confirmationModal">
        <v-toolbar v-if="formData.title" class="py-2 elevation-0 white iotyblue--text" primary-title>
          <p class="headline">{{ formData.title }}</p>
          <v-spacer></v-spacer>
          <v-btn icon light @click="$modal.hide('confirmationModal')">
              <v-icon>close</v-icon>
          </v-btn>
      </v-toolbar>
        <v-card class="pa-4">
            <v-card-text class="subheading" v-if="formData.msg">{{ formData.msg }}</v-card-text>
            <v-card-actions class="pt-5">
            <v-spacer></v-spacer>
            <v-btn v-if="formData.no" flat @click="onNo">{{ formData.no}}</v-btn>
            <v-btn v-if="formData.yes" color="error" @click.native="onYes">{{ formData.yes }}</v-btn>
            </v-card-actions>
        </v-card>
    </modal>
</template>

<script>
// import { EventBus } from './event-bus'
export default {
  data() {
    return {
      formData: {}
    }
  },
  methods: {
    beforeOpen (data) {
      console.log('params', data.params.title)
      this.formData = data.params
    },
    onNo() {
      this.$modal.show('userDataModal')
      this.$modal.hide('confirmationModal')
      return
    },
    onYes() {
      this.$modal.hide('confirmationModal')
      // EventBus.$emit('save-clicked', true)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/common/ConfirmationModal.vue